export default "__VITE_ASSET__COVf91nU__"